import React, { PropTypes } from 'react';
import { getTimeLeftLabel } from 'common/utils';

const Deadline = ({ deadline, toggleExtendModal, showExtend, showClose, toggleCloseModal }) => {
  return (<div className="sidebar-container deadline">
    <h3>Time Left</h3>

    <h1>{ getTimeLeftLabel(deadline) }</h1>

    { !deadline && <h1>Not set</h1> }

    { showExtend &&
      <button type="button" onClick={toggleExtendModal} className="btn btn-secondary btn-sm">
        Extend project
      </button> }

    { showClose &&
      <button type="button" onClick={toggleCloseModal} className="btn btn-secondary btn-sm">
        Award and proceed to wrap-up
      </button> }
  </div>);
}

Deadline.propTypes = {
  deadline: PropTypes.string,
  showExtend: PropTypes.bool,
  showClose: PropTypes.bool,
  toggleExtendModal: PropTypes.func.isRequired,
  toggleCloseModal: PropTypes.func.isRequired,
};

export default Deadline;



// WEBPACK FOOTER //
// ./project/components/deadline.jsx